import React, { useState } from 'react';
import {
  TableCell,
  Box,
  Avatar,
  IconButton,
  Typography,
  Link,
} from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon
} from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Overlay } from '../../app/feathers/overlays/Overlay';
import { Candidate } from '../../app/feathers/candidates/Candidate';
import { CirclePhoto } from '../../components';

export interface CandidateRowProps {
  overlay: Overlay;
}

export const CandidateRow: React.FC<CandidateRowProps> = ({ overlay }) => {
  const globalDocument = overlay?.globalDocument as (Candidate | undefined);
  const overlayDocument = overlay?.overlayDocument as (Candidate | undefined);

  const photo = overlay.photoPathFace || overlayDocument?.photoPathFace || globalDocument?.photoPathFace;
  const hasVariants = overlay.photoPathFace
    ? overlay.hasVariants
    : (overlayDocument?.photoPathFace ? overlayDocument?.hasVariants : globalDocument?.hasVariants);
  const name = overlay.name || overlayDocument?.name || globalDocument?.name;
  const coreDocumentDeleted = (['delete', 'edit'].includes(overlay.overlayType)) && !globalDocument;

  const raceId = overlayDocument?.race || globalDocument?.race;

  const electionKey = overlayDocument?.election || globalDocument?.election || '';
  const electionKeyAsTitle = electionKey ? electionKey.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : '';
  const link = overlay?.overlayType !== 'add' ? `/elections/${electionKey}/races/${raceId}/candidates/${overlayDocument?._id}` : undefined;

  return (
    <>
      <TableCell>
        {
          coreDocumentDeleted ? (
            <Typography variant="body1">Core Document Deleted</Typography>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CirclePhoto
                photoPath={photo}
                hasVariants={hasVariants === true}
                size="small"
              />
              <Box>
                {link ? (
                  <Link 
                    href={link}
                    target="_blank"
                    rel="noopener"
                    sx={{ 
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5
                    }}
                  >
                    <Typography variant="body1">{name}</Typography>
                    <OpenInNewIcon fontSize="small" />
                  </Link>
                ) : (
                  <Typography variant="body1">{name}</Typography>
                )}
                <Typography variant="body2" fontSize="12px">{electionKeyAsTitle}</Typography>
              </Box>
            </Box>
          )
        }
      </TableCell>
      <TableCell>
        <Typography variant="body1">{raceId}</Typography>
      </TableCell>
    </>
  );
}; 